import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetClubRatingsRequest } from './request';
import { getClubRatings } from './request';

export const useClubRatingsQuery = (
  params: GetClubRatingsRequest,
  settings?: QuerySettings<typeof getClubRatings>
) =>
  useQuery({
    queryKey: ['ClubRatings', params.clubId, params.artistProfileId],
    queryFn: () =>
      getClubRatings({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
